import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ChartsModule, ThemeService } from "ng2-charts";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { AppComponent } from "./app.component";
import { NavbarComponent } from "./shared/navbar/navbar.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SpinnerComponent } from "./shared/spinner/spinner.component";
import { ContentAnimateDirective } from "./shared/directives/content-animate.directive";
import { HomeComponent } from "./home/home.component";
import { SearchComponent } from "./search/search.component";
import { ResultComponent } from "./result/result.component";
import { ResultCriminalComponent } from "./result-criminal/result-criminal.component";
import { HistoryComponent } from "./history/history.component";
import { SettingComponent } from "./setting/setting.component";
import { SearchListComponent } from "./search-list/search-list.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { SpinnerCircularModule } from "spinners-angular/spinner-circular";
import { HistoryResultComponent } from "./history-result/history-result.component";
import { ResultSanctionComponent } from "./result-sanction/result-sanction.component";
import { ResultNSLComponent } from "./result-nsl/result-nsl.component";
import { ResultNSLEntityComponent } from "./result-nsl-entity/result-nsl-entity.component";
import { ResultEntityComponent } from "./result-entity/result-entity.component";
import { SanctionHistoryResultComponent } from "./sanction-historyresult/sanction-historyresult.component";
import { EntityResultHistoryComponent } from "./entity-historyresult/entity-historyresult.component";
import { NSLHistoryResultComponent } from "./nsl-historyresult/nsl-historyresult.component";
import { NSLEntityHistoryResultComponent } from "./nsl-entity-historyresult/nsl-entity-historyresult.component";
import { HttpinterceptorService } from "./httpinterceptor.service";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { AllCompaniesComponent } from "./all-companies/all-companies.component";
import { AllUsersComponent } from "./all-users/all-users.component";
import { NewCompanyComponent } from "./new-company/new-company.component";
import { EditCompanyComponent } from "./edit-company/edit-company.component";
import { ViewCompanyComponent } from "./view-company/view-company.component";
import { ViewUserComponent } from "./view-user/view-user.component";
import { EditUserComponent } from "./edit-user/edit-user.component";
import { NewUserComponent } from "./new-user/new-user.component";
import { AllAdminsComponent } from "./all-admins/all-admins.component";
import { ViewAdminComponent } from "./view-admin/view-admin.component";
import { EditAdminComponent } from "./edit-admin/edit-admin.component";
import { NewAdminComponent } from "./new-admin/new-admin.component";
import { InsufficientSearchCreditsComponent } from "./insufficient-search-credits/insufficient-search-credits.component";
import { CreditinfoComponent } from "./creditinfo/creditinfo.component";
import { CreditHistoryComponent } from "./credit-history/credit-history.component";
import { NgxPrintModule } from "ngx-print";
import { PrintComponent } from "./print/print.component";
import { PrintHeaderComponent } from "./print/print-header/print-header.component";
import { PrintBodyComponent } from "./print/print-body/print-body.component";
import { NewPrintComponent } from "./new-print/new-print.component";
import { NewPrintHeaderComponent } from "./new-print/new-print-header/new-print-header.component";
import { NewPrintBodyComponent } from "./new-print/new-print-body/new-print-body.component";
import { NewPrintHistoryComponent } from "./new-print-history/new-print-history.component";
import { NewPrintHistoryHeaderComponent } from "./new-print-history/new-print-history-header/new-print-header.component";
import { NewPrintHistoryBodyComponent } from "./new-print-history/new-print-history-body/new-print-history-body.component";
import { PartnerLoginTestComponent } from "./partner-login-test/partner-login-test.component";
import { PartnerSearchTestComponent } from "./partner-search-test/partner-search-test.component";
import { PartnerAdvanceSearchTestComponent } from "./partner-advance-search-test/partner-advance-search-test.component";
import { ResultAdverseMediaComponent } from "./result-adverse-media/result-adverse-media.component";
import { ResultAdverseMediaCategoryComponent } from "./result-adverse-media-category/result-adverse-media-category.component";
import { ResultAdverseMediaArticleComponent } from "./result-adverse-media-article/result-adverse-media-article.component";
import { NewPrintMediaComponent } from "./new-print-media/new-print-media.component";
import { NewPrintMediaBodyComponent } from "./new-print-media/new-print-media-body/new-print-media-body.component";
import { UserPagesModule } from "./user-pages/user-pages.module";

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    SpinnerComponent,
    ContentAnimateDirective,
    HomeComponent,
    SearchComponent,
    ResultComponent,
    ResultCriminalComponent,
    ResultSanctionComponent,
    ResultNSLComponent,
    ResultNSLEntityComponent,
    ResultEntityComponent,
    HistoryComponent,
    NSLHistoryResultComponent,
    NSLEntityHistoryResultComponent,
    SanctionHistoryResultComponent,
    EntityResultHistoryComponent,
    SettingComponent,
    SearchListComponent,
    HistoryResultComponent,
    AdminDashboardComponent,
    AllCompaniesComponent,
    AllUsersComponent,
    NewCompanyComponent,
    EditCompanyComponent,
    ViewCompanyComponent,
    ViewUserComponent,
    EditUserComponent,
    NewUserComponent,
    AllAdminsComponent,
    ViewAdminComponent,
    EditAdminComponent,
    NewAdminComponent,
    InsufficientSearchCreditsComponent,
    CreditinfoComponent,
    CreditHistoryComponent,
    PrintComponent,
    PrintHeaderComponent,
    PrintBodyComponent,
    NewPrintComponent,
    NewPrintHeaderComponent,
    NewPrintBodyComponent,
    NewPrintHistoryComponent,
    NewPrintHistoryHeaderComponent,
    NewPrintHistoryBodyComponent,
    PartnerLoginTestComponent,
    PartnerSearchTestComponent,
    PartnerAdvanceSearchTestComponent,
    ResultAdverseMediaComponent,
    ResultAdverseMediaCategoryComponent,
    ResultAdverseMediaArticleComponent,
    NewPrintMediaComponent,
    NewPrintMediaBodyComponent,
  ],
  imports: [
    NgxPrintModule,
    SpinnerCircularModule,
    Ng2SearchPipeModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    UserPagesModule,
  ],
  providers: [
    ThemeService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpinterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
